import reportsDictionary from 'Dictionaries/reports/reportsDictionary';

const pricincLevelV3Code = 3;
const pricincLevelV5Code = 5;

const highestPricingPlanCodes = ['advanced', 'enterprise', 'evolution', 'elite'];
const highestLicenceCodes = ['pack_all_included'];

export default {
    methods: {
        getLuzmoReportsAvailableForAReport(
            userPricingLevel,
            userPricingPlan,
            userLicence,
            reportCode,
        ) {
            const reportsAvailable = [];
            for (const report of reportsDictionary) {
                if (this.checkOldReportCode(reportCode, report)) {
                    if (this.checkReportPricingLevel(userPricingLevel, report)) {
                        //Pour le pricing level 3, il n'y a pas de pricing plan ni de licence
                        if (userPricingLevel === pricincLevelV3Code) {
                            reportsAvailable.push({ ...report, upsell: false });
                        } else {
                            if (this.checkReportPricingPlan(userPricingPlan, report)) {
                                reportsAvailable.push({
                                    ...report,
                                    upsell: !this.checkReportLicence(userLicence, report),
                                });
                            } else if (
                                this.checkUserPricingPlanIsLowerThanHighest(userPricingPlan)
                            ) {
                                reportsAvailable.push({ ...report, upsell: true });
                            }
                        }
                    } else if (this.checkUserPricingLevelIsLowerThanHighest(userPricingLevel)) {
                        reportsAvailable.push({ ...report, upsell: true });
                    }
                }
            }

            return reportsAvailable;
        },
        checkOldReportCode(reportCode, report) {
            return report.oldReportsCode.includes(reportCode);
        },
        checkReportPricingLevel(userPricingLevel, report) {
            return report.pricingLevels.includes(userPricingLevel);
        },
        checkReportPricingPlan(userPricingPlan, report) {
            return report.pricingPlans.includes(userPricingPlan);
        },
        checkReportLicence(userLicence, report) {
            return report.licenses.includes(userLicence);
        },
        checkUserPricingLevelIsLowerThanHighest(userPricingLevel) {
            return userPricingLevel < pricincLevelV5Code;
        },
        checkUserPricingPlanIsLowerThanHighest(userPricingPlan) {
            return !highestPricingPlanCodes.includes(userPricingPlan);
        },
        checkUserLicenceIsLowerThanHighest(userLicence) {
            return !highestLicenceCodes.includes(userLicence);
        },
    },
};
